import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SearchService } from "./search.service";


@Component({
  selector: "platform-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject();
  searching = false;


  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.searchService.searching
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(searching => this.searching = searching);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  get searchExpandClass(): string {
    return this.searching ? "search__expand" : "";
  }
}

